// extracted by mini-css-extract-plugin
export default {"homeContainer":"style_homeContainer__Mvin7","homeFeed":"style_homeFeed__SGnLP","noTweets":"style_noTweets__PrSPf","homeSuggestions":"style_homeSuggestions__lryT0"};